import { Controller } from "@hotwired/stimulus";

// Phantom power is an XLR-family thing only.
const PHANTOM_CONNECTORS = ["xlr", "xlr_combo", "mini_xlr_3pin", "mini_xlr_4pin"];

// Bus power applies to USB-family connectors only.
const USB_CONNECTORS = ["usb_a", "usb_b", "usb_c", "usb_b_mini", "usb_b_micro"];

// Drives conditional visibility on port form rows. Phantom fields show on
// XLR-family ports with the direction-appropriate field; bus power fields
// show on USB-family ports. Hidden fields reset to their schema defaults so
// wrong-context data does not get saved.
export default class extends Controller {
  static targets = ["directionSelect", "connectorSelect", "outputOnly", "inputOnly", "busPower"];

  connect() {
    this.update();
  }

  update() {
    if (!this.hasDirectionSelectTarget) return;
    const isOutput = this.directionSelectTarget.value === "output";
    const connector = this.hasConnectorSelectTarget ? this.connectorSelectTarget.value : null;
    const phantomApplies = PHANTOM_CONNECTORS.includes(connector);
    const busPowerApplies = USB_CONNECTORS.includes(connector);

    this.outputOnlyTargets.forEach((el) => {
      const show = isOutput && phantomApplies;
      el.hidden = !show;
      if (!show) this.resetField(el, 'select[name*="[phantom_power]"]', "accepted");
    });
    this.inputOnlyTargets.forEach((el) => {
      const show = !isOutput && phantomApplies;
      el.hidden = !show;
      if (!show) this.resetField(el, 'select[name*="[provides_phantom_power]"]', "not_available");
    });
    this.busPowerTargets.forEach((el) => {
      el.hidden = !busPowerApplies;
      if (!busPowerApplies) this.resetBusPower(el);
    });
  }

  resetField(wrapper, selector, defaultValue) {
    const input = wrapper.querySelector(selector);
    if (input) input.value = defaultValue;
  }

  resetBusPower(wrapper) {
    const checkbox = wrapper.querySelector('input[type="checkbox"][name*="[bus_power]"]');
    if (checkbox) checkbox.checked = false;
    wrapper.querySelectorAll('input[name*="[bus_power_voltage]"], input[name*="[bus_power_current_ma]"]').forEach((input) => {
      input.value = "";
    });
  }
}
